'use strict';

var angular = require('angular');

angular
  .module('mwl.calendar')
  .filter('calendarTrustAsHtml', ["$sce", function($sce) {

    return function(text) {
      return $sce.trustAsHtml(text);
    };

  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./src/filters/calendarTrustAsHtml.js
 ** module id = 28
 ** module chunks = 0
 **/